export default {
  MAPBOXTOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || "",
};
